import contentful, {
  flattenEntryResponse,
  flattenEntryResponseSingle,
} from '@aletheia/common/lib/contentful'

import { isEntry } from '..'
import { ISeries } from '../types/generated'

/**
 * Fetch a single Series from Contentful
 *
 * @param {string} slug The slug of this Series
 */
export const fetchSeries = async (
  slug: string,
): Promise<ISeries | undefined> => {
  return flattenEntryResponseSingle(
    await contentful.getEntries({
      content_type: 'series',
      'fields.slug': slug,
      include: 5,
    }),
  ) as ISeries | undefined
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export async function fetchSeriesEntries(slug: string) {
  const series = await fetchSeries(slug)
  return series?.fields.entries.filter(isEntry)
}

/**
 * Fetch all Series from Contentful
 *
 * @param {object} query Options to pass to contentful.getEntries()
 */
export const fetchSeriess = async (
  query?: Record<string, unknown>,
): Promise<ISeries[]> => {
  return flattenEntryResponse(
    await contentful.getEntries({
      include: 5,
      order: 'fields.title',
      ...query,
      content_type: 'series',
    }),
  ) as ISeries[]
}
